import { Routes } from '@/api/Routes';
import { http } from '@/common/utils/HttpServices';

class ActualitesService {

    public async getActualites(): Promise<any> {
        return http.get(Routes.ActualitesRoutes.GetActualites());
    }

    public async setActualiteConsulte(actualiteId: number): Promise<any>{
        return http.post(Routes.ActualitesRoutes.SetActualiteConsulte(actualiteId));
    }
}

export default new ActualitesService();
